module.exports = __webpack_public_path__ + "static/media/telescope.50c13acf.svg";